import React, {useEffect, useState} from 'react'
import {KTCard, KTCardBody} from '../../../_metronic/helpers'
import {useLazyQuery} from '@apollo/client'
import {KEY_PERFORMANCE_METRICS_DATA} from '../../../utils/GraphQLAPI'
import TeamAdminSaleschannelFilter from './TeamAdminSaleschannelFilter'
import { Spinner } from 'react-bootstrap'
import momentTimezone from 'moment-timezone'
import './teamAdmin.scss'

type Props = {
  className: string
}

const KeyPerformanceList: React.FC<Props> = ({className}) => {
  const [KPMData, setKPMData] = useState<any>([])
  const acceptanceRate = 'Acceptance Rate'
  const successRate = 'Conversion Rate'

  useEffect(() => {
    getKeyPerformancemetricsData({
      variables: {localTimeZone: momentTimezone.tz.guess(), saleChannelsIds: null},
    })
  }, [])

  // KPM Data query
  const [getKeyPerformancemetricsData, {loading :reload}] = useLazyQuery(
    KEY_PERFORMANCE_METRICS_DATA,
    {
      fetchPolicy: 'network-only',
      onCompleted: (data) => {
        setKPMData(data.getKpmByTeamAdmin)
      },
    }
  )

  // Filter
  const teamAdminSalesChannelFilter = (data: any) => {
    getKeyPerformancemetricsData(data)
  }

  return (
    <>
      <div className={`card ${className}`} style={{borderRadius: '12px'}}>
        {/* begin::Header */}
        <div className='card-header border-0 rounded-0 pt-5'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>Key Performance Metrics</span>
            <span className='text-muted mt-1 fw-semibold fs-7'>
              <strong className='text-dark'>{KPMData?.noOfReports}</strong> Total TPVs
            </span>
          </h3>
          <div className='d-flex'>
            <TeamAdminSaleschannelFilter
              getKeyPerformancemetricsData={teamAdminSalesChannelFilter}
              colors={'dark'}
            />
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <KTCard>
          <KTCardBody>
            {/* begin::Table container */}
            {reload ? (
              <div className="text-center mb-20">
                <Spinner animation="border" className="text-gray-600 text-center" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>) : (
            <div className='table-responsive-xxl'>
              {/* begin::Table */}
              <table className='table table-row-dashed table-row-gray-200 align-middle gs-0 gy-4'>
                {/* begin::Table head */}
                <thead>
                  <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                    <th className='min-w-200px' style={{paddingLeft: '22px'}}>
                      KPIs
                    </th>
                    <th className='min-w-100px header_title'>Today</th>
                    <th className='min-w-100px header_title'>Yesterday</th>
                    <th className='min-w-100px header_title'>Last Week</th>
                    <th className='min-w-100px header_title'>Last Month</th>
                    <th className='min-w-100px header_title'>Last Quarter</th>
                  </tr>
                </thead>
                {/* end::Table head */}

                {/* begin::Table body */}
                <tbody>
                  {KPMData &&
                    KPMData.kpmData?.map((data: any, i: any) => {
                      return (
                        <>
                          <tr style={{height: '55px', marginTop: '40px'}} className='border-bottom-2' key={i}>
                            <td className='min-w-200px pl-4' style={{paddingLeft: '13px'}}>
                              <span className='text-dark semi-bold d-block mb-1 fs-6 tableBodyDataStyle'>
                                {data.kpiStatus === 'Pending' &&
                                  data.tpvStatusType === 'QC' &&
                                  `TPVs ${data.kpiStatus} QC Review`}
                                {data.kpiStatus === 'Accepted' &&
                                  data.tpvStatusType === 'QC' &&
                                  `TPVs ${data.kpiStatus}`}
                                {data.kpiStatus === 'Rejected' &&
                                  data.tpvStatusType === 'QC' &&
                                  `TPVs ${data.kpiStatus}`}
                                {data.kpiStatus === acceptanceRate &&
                                  data.tpvStatusType === 'QC' &&
                                  `TPVs ${data.kpiStatus} (TPVs Accepted/Total TPVs)`}
                                {data.kpiStatus === 'Passed' &&
                                  data.tpvStatusType === 'TPV' &&
                                  `TPVs ${data.kpiStatus}`}
                                {data.kpiStatus === successRate &&
                                  data.tpvStatusType === 'TPV' &&
                                  `TPVs ${data.kpiStatus} (TPVs Passed/Total TPVs)`}
                                {data.kpiStatus === 'Not Passed' &&
                                  data.tpvStatusType === 'TPV' &&
                                  `TPVs ${data.kpiStatus} (TPV Incomplete and TPV Failed)`}
                              </span>
                            </td>
                            <td className='min-w-100px tableBodyDataStyle'>
                              <span className='text-dark semi-bold d-block mb-1 fs-6'>
                                {data.kpiStatus === acceptanceRate ||
                                data.kpiStatus === successRate
                                  ? `${
                                      Number(data.tpvToday) !== 0
                                        ? Number(data.tpvToday).toFixed(2)
                                        : Number(data.tpvToday)
                                    }%`
                                  : data.tpvToday}
                              </span>
                            </td>
                            <td className='min-w-100px tableBodyDataStyle'>
                              <span className='text-dark semi-bold d-block mb-1 fs-6'>
                                {data.kpiStatus === acceptanceRate ||
                                data.kpiStatus === successRate
                                  ? `${
                                      Number(data.tpvYesterday) !== 0
                                        ? Number(data.tpvYesterday).toFixed(2)
                                        : Number(data.tpvYesterday)
                                    }%`
                                  : data.tpvYesterday}
                              </span>
                            </td>
                            <td className='min-w-100px tableBodyDataStyle'>
                              <span className='text-dark semi-bold d-block mb-1 fs-6'>
                                {data.kpiStatus === acceptanceRate ||
                                data.kpiStatus === successRate
                                  ? `${
                                      Number(data.tpvLastWeek) !== 0
                                        ? Number(data.tpvLastWeek).toFixed(2)
                                        : data.tpvLastWeek
                                    }%`
                                  : data.tpvLastWeek}
                              </span>
                            </td>
                            <td className='min-w-100px tableBodyDataStyle'>
                              <span className='text-dark semi-bold d-block mb-1 fs-6'>
                                {data.kpiStatus === acceptanceRate ||
                                data.kpiStatus === successRate
                                  ? `${
                                      Number(data.tpvLastMonth) !== 0
                                        ? Number(data.tpvLastMonth).toFixed(2)
                                        : Number(data.tpvLastMonth)
                                    }%`
                                  : data.tpvLastMonth}
                              </span>
                            </td>
                            <td className='min-w-100px tableBodyDataStyle'>
                              <span className='text-dark semi-bold d-block mb-1 fs-6'>
                                {data.kpiStatus === acceptanceRate ||
                                data.kpiStatus === successRate
                                  ? `${
                                      Number(data.tpvLastQuarter) !== 0
                                        ? Number(data.tpvLastQuarter).toFixed(2)
                                        : Number(data.tpvLastQuarter)
                                    }%`
                                  : data.tpvLastQuarter}
                              </span>
                            </td>
                          </tr>
                        </>
                      )
                    })}
                </tbody>
                {/* end::Table body */}
              </table>
              {/* end::Table */}
            </div> )}
            {/* end::Table container */}
          </KTCardBody>
        </KTCard>
        {/* begin::Body */}
      </div>
    </>
  )
}

export {KeyPerformanceList}
